import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/challenges',
    name: 'challengesList',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "challenges" */ './views/challenges.vue')
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/challenge/:challengeId',
    name: 'challengesDetail',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "challenge-detail" */ './views/challenge-detail.vue'
        )
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/challenges/add',
    name: 'challengesAdd',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "challenge-form" */ './views/challenge-form.vue'
        )
      ),
    meta: {
      authRequired: true,
    },
  },
]
